/* tslint:disable */
/* eslint-disable */
/**
 * Referentials API
 * API for managing referentials, including countries, civility titles, and nationalities.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A coproperty from the imported RNIC national registry.
 * @export
 * @interface CoproRegistryEntryDto
 */
export interface CoproRegistryEntryDto {
    /**
     * 
     * @type {string}
     * @memberof CoproRegistryEntryDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CoproRegistryEntryDto
     */
    epci?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CoproRegistryEntryDto
     */
    numeroImmatriculation?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof CoproRegistryEntryDto
     */
    dateMiseAJour?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof CoproRegistryEntryDto
     */
    typeSyndic?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CoproRegistryEntryDto
     */
    representantLegal?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CoproRegistryEntryDto
     */
    numeroSiret?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CoproRegistryEntryDto
     */
    codeAPE?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CoproRegistryEntryDto
     */
    communeRepresentant?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CoproRegistryEntryDto
     */
    nomCopropriete?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CoproRegistryEntryDto
     */
    adresse?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CoproRegistryEntryDto
     */
    numeroVoie?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CoproRegistryEntryDto
     */
    codePostal?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CoproRegistryEntryDto
     */
    commune?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CoproRegistryEntryDto
     */
    longitude?: number;
    /**
     * 
     * @type {number}
     * @memberof CoproRegistryEntryDto
     */
    latitude?: number;
    /**
     * 
     * @type {number}
     * @memberof CoproRegistryEntryDto
     */
    nombreTotalLot?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CoproRegistryEntryDto
     */
    nombreLotUsageMultiple?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CoproRegistryEntryDto
     */
    nombreLotHabitation?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CoproRegistryEntryDto
     */
    nombreLotStationnement?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CoproRegistryEntryDto
     */
    mandatEnCours?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CoproRegistryEntryDto
     */
    periodeConstruction?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof CoproRegistryEntryDto
     */
    dateReglementCopropriete?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof CoproRegistryEntryDto
     */
    residenceService?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CoproRegistryEntryDto
     */
    syndicatCooperatif?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CoproRegistryEntryDto
     */
    typeSyndicat?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CoproRegistryEntryDto
     */
    nombreASL?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CoproRegistryEntryDto
     */
    nombreAFUL?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CoproRegistryEntryDto
     */
    nombreUnionsSyndicats?: number | null;
}

/**
 * Check if a given object implements the CoproRegistryEntryDto interface.
 */
export function instanceOfCoproRegistryEntryDto(value: object): value is CoproRegistryEntryDto {
    return true;
}

export function CoproRegistryEntryDtoFromJSON(json: any): CoproRegistryEntryDto {
    return CoproRegistryEntryDtoFromJSONTyped(json, false);
}

export function CoproRegistryEntryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CoproRegistryEntryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'epci': json['epci'] == null ? undefined : json['epci'],
        'numeroImmatriculation': json['numeroImmatriculation'] == null ? undefined : json['numeroImmatriculation'],
        'dateMiseAJour': json['dateMiseAJour'] == null ? undefined : (new Date(json['dateMiseAJour'])),
        'typeSyndic': json['typeSyndic'] == null ? undefined : json['typeSyndic'],
        'representantLegal': json['representantLegal'] == null ? undefined : json['representantLegal'],
        'numeroSiret': json['numeroSiret'] == null ? undefined : json['numeroSiret'],
        'codeAPE': json['codeAPE'] == null ? undefined : json['codeAPE'],
        'communeRepresentant': json['communeRepresentant'] == null ? undefined : json['communeRepresentant'],
        'nomCopropriete': json['nomCopropriete'] == null ? undefined : json['nomCopropriete'],
        'adresse': json['adresse'] == null ? undefined : json['adresse'],
        'numeroVoie': json['numeroVoie'] == null ? undefined : json['numeroVoie'],
        'codePostal': json['codePostal'] == null ? undefined : json['codePostal'],
        'commune': json['commune'] == null ? undefined : json['commune'],
        'longitude': json['longitude'] == null ? undefined : json['longitude'],
        'latitude': json['latitude'] == null ? undefined : json['latitude'],
        'nombreTotalLot': json['nombreTotalLot'] == null ? undefined : json['nombreTotalLot'],
        'nombreLotUsageMultiple': json['nombreLotUsageMultiple'] == null ? undefined : json['nombreLotUsageMultiple'],
        'nombreLotHabitation': json['nombreLotHabitation'] == null ? undefined : json['nombreLotHabitation'],
        'nombreLotStationnement': json['nombreLotStationnement'] == null ? undefined : json['nombreLotStationnement'],
        'mandatEnCours': json['mandatEnCours'] == null ? undefined : json['mandatEnCours'],
        'periodeConstruction': json['periodeConstruction'] == null ? undefined : json['periodeConstruction'],
        'dateReglementCopropriete': json['dateReglementCopropriete'] == null ? undefined : (new Date(json['dateReglementCopropriete'])),
        'residenceService': json['residenceService'] == null ? undefined : json['residenceService'],
        'syndicatCooperatif': json['syndicatCooperatif'] == null ? undefined : json['syndicatCooperatif'],
        'typeSyndicat': json['typeSyndicat'] == null ? undefined : json['typeSyndicat'],
        'nombreASL': json['nombreASL'] == null ? undefined : json['nombreASL'],
        'nombreAFUL': json['nombreAFUL'] == null ? undefined : json['nombreAFUL'],
        'nombreUnionsSyndicats': json['nombreUnionsSyndicats'] == null ? undefined : json['nombreUnionsSyndicats'],
    };
}

export function CoproRegistryEntryDtoToJSON(json: any): CoproRegistryEntryDto {
    return CoproRegistryEntryDtoToJSONTyped(json, false);
}

export function CoproRegistryEntryDtoToJSONTyped(value?: CoproRegistryEntryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'epci': value['epci'],
        'numeroImmatriculation': value['numeroImmatriculation'],
        'dateMiseAJour': value['dateMiseAJour'] == null ? undefined : ((value['dateMiseAJour'] as any).toISOString()),
        'typeSyndic': value['typeSyndic'],
        'representantLegal': value['representantLegal'],
        'numeroSiret': value['numeroSiret'],
        'codeAPE': value['codeAPE'],
        'communeRepresentant': value['communeRepresentant'],
        'nomCopropriete': value['nomCopropriete'],
        'adresse': value['adresse'],
        'numeroVoie': value['numeroVoie'],
        'codePostal': value['codePostal'],
        'commune': value['commune'],
        'longitude': value['longitude'],
        'latitude': value['latitude'],
        'nombreTotalLot': value['nombreTotalLot'],
        'nombreLotUsageMultiple': value['nombreLotUsageMultiple'],
        'nombreLotHabitation': value['nombreLotHabitation'],
        'nombreLotStationnement': value['nombreLotStationnement'],
        'mandatEnCours': value['mandatEnCours'],
        'periodeConstruction': value['periodeConstruction'],
        'dateReglementCopropriete': value['dateReglementCopropriete'] == null ? undefined : ((value['dateReglementCopropriete'] as any).toISOString()),
        'residenceService': value['residenceService'],
        'syndicatCooperatif': value['syndicatCooperatif'],
        'typeSyndicat': value['typeSyndicat'],
        'nombreASL': value['nombreASL'],
        'nombreAFUL': value['nombreAFUL'],
        'nombreUnionsSyndicats': value['nombreUnionsSyndicats'],
    };
}

